import { BranchDesignator, flowmapBranchDesignator, FlowmapParser, FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { err, ok, Result } from 'neverthrow'
import { CloudToDeviceBlobType, CloudToDeviceBlobUpnAll, selectCloudToDeviceBlob } from '../dal/ldbCloudToDeviceBlob'
import { FlowmapRendererInfo, rendererInfoFromFlowmapParser } from '../lib/flowmapBranchInfo'

export interface PreviewBranchInfo extends FlowmapRendererInfo {
	branchDesignator: BranchDesignator
}

// reads the preview branch's designator and live renderer info from its
// flowmap, as downloaded (with ?branchInfo=1) by the preview sync
export const selectPreviewBranchInfo = async (branchGuid: string): Promise<Result<PreviewBranchInfo, FusionError>> => {
	const rFlow = await selectCloudToDeviceBlob({
		type: CloudToDeviceBlobType.Flowmap,
		id: branchGuid,
		upn: CloudToDeviceBlobUpnAll,
	})
	if(rFlow.isErr()) {
		return err(serializeFusionError('selectPreviewBranchInfo', rFlow.error))
	}
	if(!rFlow.value) {
		return err(serializeFusionError('selectPreviewBranchInfo', `no flowmap for branch ${branchGuid}`))
	}
	const flowXml = new TextDecoder().decode(rFlow.value.data)
	const branchDesignator = flowmapBranchDesignator(flowXml)
	if(!branchDesignator) {
		return err(serializeFusionError('selectPreviewBranchInfo', `branch ${branchGuid} has no branchDesignator on its flowmap`))
	}
	const rParser = FlowmapParser.create(flowXml)
	if(rParser.isErr()) {
		return err(rParser.error)
	}
	const rRendererInfo = rendererInfoFromFlowmapParser(rParser.value)
	if(rRendererInfo.isErr()) {
		return err(rRendererInfo.error)
	}
	return ok({
		branchDesignator,
		...rRendererInfo.value,
	})
}
